import z from "zod";
import type { Context } from "hono";

export const projectVariableSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export type ProjectVariable = z.infer<typeof projectVariableSchema>;
export type ManagedVariable = {
  key: string;
};

export const getProjectVariablesRequestBodySchema = z.object({});

export type GetProjectVariablesRequestBody = z.infer<
  typeof getProjectVariablesRequestBodySchema
>;

export type GetProjectVariablesResponseBody = {
  variables: ProjectVariable[];
  managedVariables: ManagedVariable[];
};

export type GetProjectVariablesHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      | GetProjectVariablesResponseBody
      | { error: string }
      | { errors: z.ZodIssue[] }
      | string
    >
  >
>;

export const patchProjectVariablesRequestBodySchema = z.object({
  variables: z.array(projectVariableSchema),
});

export type PatchProjectVariablesRequestBody = {
  variables: ProjectVariable[];
};

export type PatchProjectVariablesResponseBody = {
  variables: ProjectVariable[];
};

export type PatchProjectVariablesHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      | PatchProjectVariablesResponseBody
      | { error: string }
      | { errors: z.ZodIssue[] }
      | string
    >
  >
>;
